import request from '@/utils/request'

/**
 * 获取地区列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getAreaList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/area.listAreas',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取商铺类型列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getShopTypes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopType.queryShopType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 注册商铺
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function registerStore(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.registerStoreAndShop',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 发送短信验证码
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function sendSms(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.userSendSms',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}